<template>
    <a-drawer :title="title" width="900" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="课程信息" bordered :column="1" size="middle">
            <a-descriptions-item label="课程名称">
                {{ detail.name }}
            </a-descriptions-item>
            <a-descriptions-item label="课程类型">
                <a-tag color="#f50">
                    {{ detail.type | fmtCourseType }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="课程级别">
                <a-tag color="#108ee9">
                    {{ detail.level }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="学习周期">
                {{ detail.cycle }}
            </a-descriptions-item>
            <a-descriptions-item label="课程学时">
                {{ detail.hours }}
            </a-descriptions-item>
            <a-descriptions-item label="学习方式">
                {{ detail.online ? '线上学习' : '线下学习' }}
            </a-descriptions-item>
            <a-descriptions-item label="课程费用">
                <span>{{ detail.amt }} 元</span>
            </a-descriptions-item>
            <a-descriptions-item label="专业分类">
                <span>{{ detail.cata }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="举办单位">
                {{ detail.sponsor }}
            </a-descriptions-item>
            <a-descriptions-item label="组织单位">
                {{ detail.orgunit }}
            </a-descriptions-item>
            <a-descriptions-item label="报名条件">
                {{ detail.regq }}
            </a-descriptions-item>
            <a-descriptions-item label="课程详情">
                {{ detail.info }}
            </a-descriptions-item>
            <a-descriptions-item label="课程导师">
                {{ detail.cta.name }}
            </a-descriptions-item>
            <a-descriptions-item label="发放证书">
                <a-tag color="#2db7f5" v-for="cert in mcert" :key="cert.id">
                    <span>{{ cert.name }} [ {{ cert.lv }} ]</span>
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="附加证书">
                <a-tag color="#87d068" v-for="cert in scert" :key="cert.id">
                    <span>{{ cert.name }} [ {{ cert.lv }} ]</span>
                </a-tag>
            </a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <div class="ant-descriptions-title">证书图片</div>
        <a-row :gutter="[10, 10]">
            <a-col :span="6" v-for="img in images" :key="img">
                <div :style="{ width: '100px', height: '100px', border: '1px dashed grey', padding: '3px' }">
                    <img :src="img" :style="{ width: '100%', height: '100%' }" />
                </div>
            </a-col>
        </a-row>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        images() {
            return this.detail.imgs.split(',')
        },
        mcert() {
            return this.detail.certs.filter(c => c.main)
        },
        scert() {
            return this.detail.certs.filter(c => !c.main)
        }
    },
    data() {
        return {
            detail: {
                imgs: '',
                cta: {},
                certs: []
            }
        }
    },
    mounted() {
        this.$http
            .get('/crs/train/course/detail', {
                params: {
                    id: this.item.id
                }
            })
            .then(result => {
                this.detail = result.data
            })
    }
}
</script>
